export const withMarginOptions = {
  threshold: 0,
  rootMargin: '25% 0% 25% 0%',
}

export const defaultOptions = {
  threshold: 0,
  rootMargin: '0px',
}
